import axios from "axios";
const instance = axios.create({
  baseURL: 'https://netease-cloud-music-api-chi-sage.vercel.app/',
  timeout: 8000,
});
export default instance